import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-screen__header" }
const _hoisted_2 = { class: "settings-screen__header__back-button_content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1 /* HOISTED */)
const _hoisted_4 = { class: "settings-screen__header__main-content-wrapper" }
const _hoisted_5 = { class: "settings-screen__header__title-content-wrapper" }
const _hoisted_6 = { class: "settings-screen__header__actions-block-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "settings-screen__header__back-button_wrapper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_icon, {
          class: "settings-screen__header__back-button_icon",
          size: "16"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.Back)))
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(`Settings for ${_ctx.selectedCountryName}`), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          loading: _ctx.isLoading,
          disabled: _ctx.isSaveButtonDisabled,
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.PresetSettingsButtonName.SAVE), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["loading", "disabled"])
      ])
    ])
  ]))
}